import { useState, useEffect } from "react";
import { Sample } from "@/comn/components/_";
import { Layout, Button, Pdf } from "@/comn/components";
import { useModal, useFetch } from "@/comn/hooks";
import "prismjs/themes/prism.css";

export const GuideXml = () => {
    const modal = useModal();
    const [xmlData, setXmlData] = useState<any>(null);

    useEffect(() => {
        setXmlData(
            `<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
            <ns0:getEACSeaManifestsResponse xmlns:ns0="http://services.mms10.kra.go.ke/">
                <return>
                    <responseCode>1</responseCode>
                    <comments>Request [SCT GetEACSeaManifests] Success. </comments>
                </return>
            </ns0:getEACSeaManifestsResponse>
        </soap:Body>
    </soap:Envelope>`,
        );
    }, []);

    return (
        <Sample title="XML 뷰어" description="">
            <Sample.Section title="1. XML 뷰어 기본 기능">
                <Layout>
                    <Layout.Right>
                        <Button onClick={() => {}}>모달로 띄우기</Button>
                    </Layout.Right>
                </Layout>
                <pre className="xml lang-html ">
                    <code>{xmlData}</code>
                </pre>
            </Sample.Section>
        </Sample>
    );
};
